import { FlowSpecDto } from '@ampsec/platform-client';
import { isPendingEngagementsFilterByFindingsEnabled } from 'Core-utils/featureFlags/pendingEngagementsFilterByFindings';

export const COLUMN_STATE_STORAGE_KEYS = {
  server: 'engagementFlowGridColumnState',
} as const;

export interface AgGridEngagementFlowProps {
  onDuplicate: (flowSpec: FlowSpecDto) => void;
  tableBodyHeight?: string;
}

export const DEFAULT_COLUMN_STATE = [
  { colId: 'name', hide: false, sort: 'asc' as const },
  { colId: 'filter', hide: false, sort: null },
  { colId: 'findingKinds', hide: false, sort: null },
  { colId: 'tagFilters', hide: true, sort: null },
  { colId: 'lastTriggered', hide: false, sort: null },
  { colId: 'total', hide: false, sort: null },
  { colId: 'active', hide: false, sort: null },
  { colId: 'avgHealingTime', hide: false, sort: null },
  { colId: 'status', hide: false, sort: null },
  { colId: 'actions', hide: false, sort: null },
];

export function getDefaultEngagementFlowColumnState() {
  if (isPendingEngagementsFilterByFindingsEnabled()) {
    return DEFAULT_COLUMN_STATE;
  }
  return DEFAULT_COLUMN_STATE.filter((col) => col.colId !== 'tagFilters');
}

/** Default AgGridBase row height for this grid. */
export const ENGAGEMENT_FLOW_ROW_HEIGHT = 50;

/** Extra height per additional target finding row (1.25rem line + 0.25rem gap). */
export const ENGAGEMENT_FLOW_FINDING_LINE_HEIGHT = 24;
